import Onboarding from "../Onboarding/Onboarding";

export default Onboarding;
